import { Node } from 'data/types'
import React from 'react'
import styled from 'styled-components'
import { color, fontSize } from 'utils'

const InputWrapper = styled.div`
  display: grid;
  gap: 0.5rem;
  margin-bottom: 1rem;
`

const Input = styled.input`
  padding: 1rem;
  border: 1px solid ${color('light')};
  border-radius: 8px;
  &::placeholder {
    color: ${color('grey400')};
    font-weight: 500;
  }
`

const InputLabel = styled.label`
  margin: 0;
  color: ${color('grey900')};
  font-size: ${fontSize('sm')};
`

type ExtraQuestionProps = {
  onChange: (input: string) => void
  question: Node
}

const ExtraQuestionInput = ({ onChange, question }: ExtraQuestionProps) => {
  if (question.type !== 'OPEN_ENDED') return null
  return (
    <InputWrapper>
      {question.text !== '' && <InputLabel>{question.text}</InputLabel>}
      <Input
        placeholder={question.hint}
        onChange={(e) => onChange(e.target.value)}
        value={question.input}
      />
    </InputWrapper>
  )
}

export default ExtraQuestionInput
